var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7852,
    cy: 33.2551,
    rx: 0.821443,
    ry: 0.829924,
    transform: "rotate(-180 34.7852 33.2551)",
    fill: "white",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3915 26.8393C10.3915 25.2752 11.4334 24.8842 11.9543 24.8842C10.7041 24.8842 10.3915 23.4504 10.3915 22.929C10.3915 24.1803 9.3496 24.8842 8.82865 24.8842C10.0789 24.8842 10.3915 26.1876 10.3915 26.8393Z",
    fill: "url(#paint0_linear_431_3163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8036 33.4052C14.5638 37.9124 22.483 43.1256 23.7405 43.936C23.8488 44.0058 23.9753 44.0113 24.0896 43.9519C25.3595 43.292 33.0232 39.1656 36.601 33.9039C42.2647 25.5746 42.4157 8.78952 42.4069 6.3444C42.4063 6.16466 42.2763 6.0251 42.0985 5.99859C40.1323 5.70549 29.1938 4.11006 24.0601 4.11006C19.0387 4.11006 8.28983 5.69827 6.31519 5.99658C6.13417 6.02393 6.00147 6.16872 6.00544 6.35174C6.05785 8.77263 6.59939 24.9071 11.8036 33.4052Z",
    fill: "url(#paint1_linear_431_3163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6537 30.9817C16.9666 34.7336 23.981 39.1246 23.981 39.1246C23.981 39.1246 30.7482 35.7624 33.7592 31.3634C38.4726 24.4772 38.2306 10.0401 38.2306 10.0401C38.2306 10.0401 28.4523 8.55943 24.0969 8.55943C19.8271 8.55943 10.1824 10.0401 10.1824 10.0401C10.1824 10.0401 10.3116 23.938 14.6537 30.9817Z",
    fill: "url(#paint2_linear_431_3163)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6379 13.5C10.6379 15.5 9.30461 16 8.63794 16C10.2379 16 10.6379 17.8333 10.6379 18.5C10.6379 16.9 11.9713 16 12.6379 16C11.0379 16 10.6379 14.3333 10.6379 13.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.1762 6.04456C42.1762 6.04456 42.7553 25.0031 36.6377 34C33.031 39.3042 25.3129 43.3914 24.1377 44L24.1377 4.00001C26.1912 4.00001 27.9004 4.17493 30.8584 4.50001C31.3292 4.55175 33.3584 5.00001 33.3584 5.00001C33.3584 5.00001 34.5677 5.05541 34.5677 5.07731C39.0451 5.61075 42.1762 6.04456 42.1762 6.04456Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5266 18.5C37.5266 20.3889 36.2673 20.8611 35.6377 20.8611C37.1488 20.8611 37.5266 22.5926 37.5266 23.2222C37.5266 21.7111 38.7858 20.8611 39.4155 20.8611C37.9044 20.8611 37.5266 19.287 37.5266 18.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_431_3163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 37,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 20.5C15.764 25.0138 22.8154 27.5741 23.9148 27.9513C24.0105 27.9841 24.1089 27.9731 24.1963 27.9221C25.0255 27.4379 29.471 24.6899 33 19.5C37.9607 12.2045 41.0599 7.82085 42.0548 6.42373C42.2144 6.19945 42.0845 5.8863 41.8122 5.84611C39.2447 5.46726 28.9831 4.00001 24.0599 4.00001C19.1017 4.00001 8.55955 5.54845 6.39375 5.87465C6.17875 5.90703 6.04852 6.11602 6.11169 6.32407C6.53262 7.71039 8.2476 12.74 12.9998 20.5Z",
    fill: "url(#paint3_linear_431_3163)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_431_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8235 4L22 13.0588L20.7059 15H29.1176L36.8823 4H27.8235Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8823 4H33.647L25.8823 15H29.1176L36.8823 4Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0588 4L25.8824 13.0588L27.1765 15H18.7647L11 4H20.0588Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4H16.6983L23.9412 15H18.7647L11 4Z",
    fill: "#676767"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6483 13.8834L24.2464 10.587L32.8446 13.8834C33.0675 13.9688 33.2596 14.1217 33.3953 14.3217C33.5309 14.5216 33.6036 14.7592 33.6037 15.0025V20.1522C33.6037 23.9508 31.9989 27.5652 29.2023 30.0665L24.2464 34.5L19.2906 30.0665C17.9082 28.83 16.8003 27.3058 16.0412 25.5958C15.282 23.8859 14.8893 22.0299 14.8892 20.1522V15.0025C14.8892 14.7592 14.962 14.5216 15.0976 14.3217C15.2333 14.1217 15.4254 13.9688 15.6483 13.8834Z",
    fill: "#E7C605"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7495 12.684L24.2391 9.5L32.7287 12.684C32.9488 12.7665 33.1385 12.9142 33.2724 13.1074C33.4064 13.3005 33.4782 13.53 33.4783 13.765V18.7391C33.4783 22.4082 31.8937 25.8995 29.1324 28.3155L24.2391 32.5978L19.3459 28.3155C17.9809 27.1212 16.887 25.6488 16.1374 23.9972C15.3879 22.3456 15.0001 20.5529 15 18.7391V13.765C15.0001 13.53 15.0719 13.3005 15.2058 13.1074C15.3398 12.9142 15.5294 12.7665 15.7495 12.684Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.594 20.1586C30.0032 17.3634 27.7347 15.6838 25.3113 15.4233V15.0562C25.3113 14.6933 25.0159 14.4 24.6502 14.4C24.2846 14.4 23.9891 14.6933 23.9891 15.0562V15.4233C21.5575 15.6838 19.3097 17.3634 18.7064 20.1586C18.661 20.3657 18.882 20.5954 19.0928 20.3924C20.1671 19.2644 21.3178 19.3178 22.3694 21.1512C22.4789 21.346 22.6772 21.3275 22.7764 21.1512C23.1937 20.4252 23.704 19.65 24.6502 19.65C25.8588 19.65 26.4724 21.0609 26.5241 21.1512C26.6232 21.3275 26.8216 21.346 26.9311 21.1512C27.9847 19.3157 29.1437 19.2768 30.2077 20.3924C30.4205 20.5975 30.6395 20.3657 30.594 20.1586ZM23.9891 20.5872V23.2594C23.9891 23.4398 23.8404 23.5875 23.6586 23.5875C23.4974 23.5875 23.3859 23.4788 23.3466 23.3681C23.2247 23.0256 22.8487 22.8472 22.5037 22.9682C22.1587 23.0892 21.9789 23.4644 22.1008 23.8049C22.3322 24.4591 22.9603 24.8979 23.6586 24.8979C24.5697 24.8979 25.3113 24.1617 25.3113 23.2573V20.5852C25.1233 20.4231 24.9023 20.3062 24.6502 20.3062C24.3961 20.3083 24.1875 20.4047 23.9891 20.5872Z",
    fill: "#0071BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_3163",
    x1: 8.99761,
    y1: 27.0255,
    x2: 10.6457,
    y2: 22.7394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_3163",
    x1: 15.3086,
    y1: 2.36901,
    x2: 25.3607,
    y2: 46.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_431_3163",
    x1: 11.4398,
    y1: 10.0103,
    x2: 24.9813,
    y2: 41.1558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_431_3163",
    x1: 15.3086,
    y1: 2.25893,
    x2: 25.3607,
    y2: 46.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEED6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_3163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9,
    height: 10.5,
    fill: "white",
    transform: "translate(18.7 14.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.3ab0016c.svg";
export { ForwardRef as ReactComponent };